<template>
  <div style="background-color: white; min-height: 100vh; overflow-y: auto">
    <div class="vg-content">
      <van-image class="logo" width="100" height="50" :src="srcLogo"/>
      <div class="slogan">欢迎使用 电子出入证</div>
      <div class="entry">
        <span class="title">邀请码</span>
        <van-field class="text" v-model="inviteCode" type="text" placeholder="请输入邀请码，不区分大小写" :maxlength="5"
                   :border="false" center/>
      </div>
      <div class="entry">
        <span class="title">姓名</span>
        <van-field class="text" v-model="userName" type="text" placeholder="请输入姓名" :maxlength="32" :border="false"
                   center/>
      </div>
      <div class="entry">
        <span class="title">手机号</span>
        <van-field class="text" v-model="userPhone" type="tel" placeholder="请输入手机号" :maxlength="11"
                   :border="false" center/>
      </div>
      <div class="entry">
        <span class="title">验证码</span>
        <div class="content">
          <van-field class="code" v-model="verifyCode" type="digit" placeholder="请输入验证码" :maxlength="4"
                     :border="false" center/>
          <div class="get-code" :class="{disabled: isGetCode}" @click="onGetCode">{{ strGetCode }}</div>
        </div>
      </div>
      <vg-button class="button" type="primary" @click="onSubmit">注册</vg-button>
      <div class="back" @click="onBackLogin">返回登录</div>

      <div class="footer">
        <van-checkbox v-model="checked" icon-size="20px">已阅读并同意
          <span style="color: #4BA9F6;" @click.stop="userAgreement">《用户协议》</span> 和
          <span style="color: #4BA9F6;" @click.stop="privacyPolicy">《隐私政策》</span>
        </van-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import srcLogo from "@/assets/login/kaidelogo.png";
import {Checkbox, Field, Image as VanImage, Toast} from "vant";
import VgButton from "@/components/Commons/VgButton";
import {client} from "@/libraries/http";
import validate from "@/filters/validate";
import useAuthnStore from "@/store/authn";

export default {
  name: "UserRegister",
  components: {
    VanImage, VgButton, "van-field": Field, "van-checkbox": Checkbox,
  },
  data() {
    return {
      srcLogo: srcLogo,
      inviteCode: "",
      userName: "",
      userPhone: "",
      verifyCode: "",
      isGetCode: false,
      strGetCode: "获取验证码",
      checked: false,
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    onGetCode() {
      if (this.isGetCode) {
        return;
      }
      if (!this.checkInput(false)) {
        return;
      }
      let params = {
        account: this.userPhone,
        bizType: "REGISTER",
      };
      client.post("/api/public/verifycode", params).then(() => {
        Toast.success('发送成功');
        this.isGetCode = true;
        this.strGetCode = "60秒倒计时";
        this.count = 60;
        this.timer = setInterval(() => this.countDown(), 1000);
      })
    },
    countDown() {
      this.count--;
      if (this.count > 0) {
        this.strGetCode = this.count + "秒倒计时";
      } else {
        clearInterval(this.timer);
        this.isGetCode = false;
        this.strGetCode = "获取验证码";
      }
    },
    onSubmit() {
      if (!this.checkInput(true)) {
        return;
      }
      let params = {
        inviteCode: this.inviteCode,
        name: this.userName,
        phone: this.userPhone,
        verifyCode: this.verifyCode,
      };
      client.post("/api/public/register", params).then(res => {
        console.log(res);
        const authn = useAuthnStore();
        authn.token({
          token: res.data.token,
          user: {
            loginType: res.data.loginType,
            userName: res.data.userName,
            userPhone: res.data.userPhone
          }
        });
        this.$toast.success("注册成功")
        this.$router.replace({path: '/myElectronicPass'});
      })
    },
    onBackLogin() {
      this.$router.replace({path: '/'});
    },
    userAgreement() {
      // this.$router.push({path: '/userAgreement'});
      window.location.href = process.env.VUE_APP_ROUTER_BASE_URL + 'user-agreement-1.0.html'
    },
    privacyPolicy() {
      // this.$router.push({path: '/privacyPolicy'});
      window.location.href = process.env.VUE_APP_ROUTER_BASE_URL + 'privacy-policy-1.0.html'
    },
    checkInput(isRegister) {
      if (!this.inviteCode) {
        Toast("请输入邀请码");
        return false;
      }
      if (!this.userName) {
        Toast("请输入姓名");
        return false;
      }
      if (!this.userPhone) {
        Toast("请输入手机号");
        return false;
      }
      if (!validate.isPhone(this.userPhone)) {
        Toast("手机号格式不正确，请重新输入");
        return false;
      }
      if (isRegister && !this.verifyCode) {
        Toast("请输入验证码");
        return false;
      }
      if (isRegister && !this.checked) {
        Toast("请先阅读并同意协议");
        return false;
      }
      return true;
    },
  },
}
</script>

<style scoped>
.vg-content {
  margin: 30px 40px 0;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-items: stretch;
}

.logo {
  align-self: flex-start;
}

.slogan {
  margin-top: 15px;
  margin-bottom: 15px;
  font-weight: bold;
  color: #101010;
  font-size: 22px;
}

.entry {
  margin: 15px 0px 0px;
  display: flex;
  flex-direction: column;
}

.title {
  margin-top: 0px;
  color: #101010;
  font-size: 14px;
}

.text {
  margin-top: 5px;
  padding-left: 0px;
  padding-right: 0px;
  height: 40px;
  color: #101010;
  font-size: 16px;
  border-bottom: 1px solid #E5E5EA;
}

.content {
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #E5E5EA;
}

.code {
  padding-left: 0px;
  padding-right: 0px;
  height: 40px;
  color: #101010;
  font-size: 16px;
}

.get-code {
  margin-left: 15px;
  color: #4BA9F6;
  font-size: 14px;
  flex-shrink: 0;
}

.disabled {
  color: #B4B4B4;
}

::v-deep .van-field__control::placeholder {
  color: #AEAEB2 !important;
}

::v-deep .van-field__control::-webkit-input-placeholder { /* 使用webkit内核的浏览器 */
  color: #AEAEB2 !important;
}

::v-deep .van-field__control:-moz-placeholder { /* Firefox版本4-18 */
  color: #AEAEB2 !important;
}

::v-deep .van-field__control::-moz-placeholder { /* Firefox版本19+ */
  color: #AEAEB2 !important;
}

::v-deep .van-field__control:-ms-input-placeholder { /* IE浏览器 */
  color: #AEAEB2 !important;
}

.button {
  margin-top: 60px;
  height: 44px;
}

.back {
  margin-top: 20px;
  align-self: center;
  color: #4BA9F6;
  font-size: 14px;
}

.footer {
  margin-top: 30px;
  color: #101010;
  font-size: 12px;
  align-self: center;
}

</style>
